import React from 'react'
import { useIntl } from 'gatsby-plugin-intl'
import Layout from '../../components/Layout/index'
import Header from '../../modules/Header'
import Footer from '../../modules/Footer'
import SEO from '../../components/seo'
import PressRelease from '../../components/PressRelease'

import messages from '../../messages/pageTitles.lang'
import metaDescription from '../../messages/pageMetaDescriptions.lang'
import Image from '../../images/news/mefa-shop_1_1_en.png'
import ImageDE from '../../images/news/mefa-shop_1_1_de.png'

import { newsList } from '../../components/NewsPage/data'

const IndexPage = () => {
  const { formatMessage, locale } = useIntl()

  return (
    <Layout footer={<Footer />} header={<Header withTeaser />}>
      <SEO
        title={formatMessage(messages.TitleNewsMefaShop)}
        imageAlt={formatMessage(messages.TitleNewsMefaShop)}
        description={formatMessage(metaDescription.NewsMefaShopDescription)}
        image={locale === 'de' ? ImageDE : Image}
        lang={locale}
      />
      <PressRelease
        article={newsList.mefaShop}
      />
    </Layout>
  )
}

export default IndexPage
